export const SETTINGS_READ_GUIDELINES =
    "https://storage.googleapis.com/stage-avy-api-user-generated-assets/4010c9a5-497a-462d-a912-760c36596c0b.pdf"
export const CONTENT_GUIDELINES =
    "https://storage.googleapis.com/stage-avy-api-user-generated-assets/a74c5f84-40a8-4860-80c4-063add9ec669.pdf"
export const CONTENT_READ_GUIDELINES = {
    en: "https://storage.googleapis.com/stage-avy-api-user-generated-assets/aed89f0d-36b8-4c6b-b11c-8e9728b859d7.pdf",
    sv: "https://storage.googleapis.com/stage-avy-api-user-generated-assets/ef6e9efe-19b7-43df-b52f-079283c99ba7.pdf",
}
